import {useState} from "react";
import Loader from "./app/elements/loader";
import RootLayout from "./layouts/root-layout";
import ScrollToTop from "./app/elements/ScrollToTop";
import CookieBanner from "../src/app/components/CookieBanner";
import AnalyticsTracker from "../src/app/components/AnalyticsTracker";
import CallbackPopup from "../src/app/components/CallbackPopup";
import {Toaster} from 'react-hot-toast';

export default function App() {
  const [isLoading, setIsLoading] = useState(true);

  setTimeout(() => {
    setIsLoading(false);
  }, 500);

  return (
    <>

      {
        isLoading && <Loader/>
      }
      <ScrollToTop/>
      <AnalyticsTracker/>
      <RootLayout/>
      <Toaster position={'bottom-center'}/>
      <CookieBanner/>
      <CallbackPopup/>
    </>
  );
}
